import { render, staticRenderFns } from "./SVGWrench.vue?vue&type=template&id=1bbf11a0&scoped=true&"
import script from "./SVGWrench.vue?vue&type=script&lang=js&"
export * from "./SVGWrench.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbf11a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bbf11a0')) {
      api.createRecord('1bbf11a0', component.options)
    } else {
      api.reload('1bbf11a0', component.options)
    }
    module.hot.accept("./SVGWrench.vue?vue&type=template&id=1bbf11a0&scoped=true&", function () {
      api.rerender('1bbf11a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGWrench.vue"
export default component.exports